"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagedSmsLogsResponseToJSON = exports.PagedSmsLogsResponseFromJSONTyped = exports.PagedSmsLogsResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function PagedSmsLogsResponseFromJSON(json) {
    return PagedSmsLogsResponseFromJSONTyped(json, false);
}
exports.PagedSmsLogsResponseFromJSON = PagedSmsLogsResponseFromJSON;
function PagedSmsLogsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'page': !runtime_1.exists(json, 'page') ? undefined : json['page'],
        'pageSize': !runtime_1.exists(json, 'pageSize') ? undefined : json['pageSize'],
        'count': !runtime_1.exists(json, 'count') ? undefined : json['count'],
        'logs': !runtime_1.exists(json, 'logs') ? undefined : (json['logs'].map(_1.SmsLogFromJSON)),
    };
}
exports.PagedSmsLogsResponseFromJSONTyped = PagedSmsLogsResponseFromJSONTyped;
function PagedSmsLogsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'page': value.page,
        'pageSize': value.pageSize,
        'count': value.count,
        'logs': value.logs === undefined ? undefined : (value.logs.map(_1.SmsLogToJSON)),
    };
}
exports.PagedSmsLogsResponseToJSON = PagedSmsLogsResponseToJSON;
